import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.fromTo('.js-kv-animation',
  {
    autoAlpha: 0,
    y: 40
  },
  {
    autoAlpha: 1,
    duration: 1,
    y: 0,
    scrollTrigger: {
      trigger: '.js-kv-animation',
      start: 'top center', 
      // markers: true,
      toggleActions: 'play none none reverse'
    }
});

// gsap.fromTo('.js-cta-animation',
//   {
//     // autoAlpha: 0,
//     y: 0,
//     scale: 0.9
//   },
//   {
//     scale: 1,
//     autoAlpha: 1,
//     duration: 0.7,
//     y: 0,
//     scrollTrigger: {
//       trigger: '.js-kv-animation',
//       start: '-150px top', 
//       markers: true,
//       toggleActions: 'play none none reverse'
//     }
// });

gsap.utils.toArray(".js-scroll-animation").forEach(target => {
  gsap.from(target, {
    autoAlpha: 0,
    y: 100,
    duration: 0.8,
    scrollTrigger: {
      trigger: target,
      start: 'top 90%', // アニメーション開始位置
      end: 'top bottom', // アニメーション終了位置
      // markers: true,
      toggleActions: 'play none none reverse'
    }
  });
});

